/*
* Copyright (c) Akveo 2019. All Rights Reserved.
* Licensed under the Single Application / Multi Application License.
* See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
*/
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "./../../../../environments/environment";
import { TokenStorageService } from '../../../services/token-storage.service';
const API_URL = environment.apiUrl + 'academy';
@Injectable(
  {
    providedIn: "root"
  }
)
export class AcademyService {
  authtoken: string;
  private httpOptions;
  constructor(private http: HttpClient, private token: TokenStorageService) {
    this.authtoken = this.token.getToken();
    this.httpOptions = {
      headers: new HttpHeaders()
        .set("Content-Type", "application/json")
        .set('Authorization', `Bearer ${this.authtoken}`)
    };
  }
  getAcademyList(query): Observable<any> {
    return this.http.get<any>(API_URL + query, this.httpOptions);
  }
  resetAcademyOrder(formData:FormData) {
    return this.http.post<any>(`${API_URL}/reorder/csv`,formData);
  }
  getAcademyDetails(id: string) {
    return this.http.get<any>(`${API_URL}/${id}`, this.httpOptions);
  }
  addAcademy(academy) {
    return this.http.post<any>(API_URL, academy, this.httpOptions);
  }
  updateAcademy(id: string, academy): Observable<any> {
    return this.http.put(API_URL + '/' + id, academy, this.httpOptions);
  }
  updateAcademyStatus(id: string, academy): Observable<any> {
    return this.http.put(API_URL + '/update/' + id, academy, this.httpOptions);
  }
  getAcademyLocation(): Observable<any> {
    return this.http.get<any>(API_URL + "/location", this.httpOptions);
  }
  updateOrder(academy) {
    return this.http.post<any>(API_URL + "/reorder", academy, this.httpOptions);
  }
  changeOrder(academyid,data) {
    return this.http.put<any>(API_URL + "/updateorder/"+academyid, data, this.httpOptions);
  }
  verifyGst(academy) {
    return this.http.post<any>(API_URL + "/verify-gstin", academy, this.httpOptions);
  }
  addAcademyValidations(academy) {
    return this.http.post<any>(API_URL + "/validations", academy, this.httpOptions);
  }
}
